import { DbRef, ShiftOfferStatus, TrackingEvent } from '@caresend/types';
import { formatFullName } from '@caresend/utils';
import 'dayjs';
import { useItineraryGeoSearch } from '../components/specific/portal/components/useItineraryGeoSearch.js';
import { usePortalStore } from '../components/specific/portal/store/portal/index.js';
import 'firebase/auth';
import { cancelShiftAsNurseRequest } from '../database/firebaseConfig/cloudFunctions.js';
import '../database/firebaseConfig/init.js';
import { dbGroupSet } from '../database/firebaseConfig/methods.js';
import '@sentry/vue';
import { toastSuccess, toastError } from './toast/toast.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../components/ui/Icon.vue.js';
import './configuration/icons.js';
import '../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import './tracking/index.js';
import { trackEvent } from './tracking/tracking.js';
import { getStore } from '../store/helpers/initStore.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import '../store/modules/app/model.js';
import './supplies/scanning.js';
import '../store/modules/procedures/model.js';
import 'immutability-helper';
import { getRouter } from '../router/helpers/initRouter.js';
import '../router/routes/dev/model.js';
import '../router/routes/dev/routes.js';
import '../router/routes/dashboard/model.js';
import '../router/routes/pro/model.js';
import '../router/routes/visitsPage/model.js';
import '../router/routes/orderFlow/model.js';
import '../router/routes/orderFlow/privateHelpers.js';
import '../router/routes/orderFlow/routes.js';
import '../router/routes/schedulingFlow/model.js';
import '../router/routes/schedulingFlow/routes.js';
import '../router/routes/chartingFlow/model.js';
import '../router/routes/chartingFlow/routes.js';
import '../router/routes/portal/portalRoutes.js';
import { portalJobsRoute } from '../router/routes/portal/locations.js';
import '../router/routes/portal/model.js';
import '../router/routes/visitsPage/routes.js';

/**
 * Decline a shift offer. Use this high priority function to decline an offer.
 * and sidestep record manager.
 * @param shiftID - The ID of the shift
 * @param declineReason - The reason/explanation for declining the offer
 * @returns void
 */
const declineShiftOffer = async (shiftID, declineReason) => {
    var _a, _b, _c;
    const store = getStore();
    const { shifts, offices } = usePortalStore();
    const shift = shifts.getRaw(shiftID);
    const nurseID = (_a = store.state.auth.user) === null || _a === void 0 ? void 0 : _a.id;
    const nurseFullName = formatFullName(store.state.auth.user);
    const staffingOfficeID = Object.keys((_b = shift === null || shift === void 0 ? void 0 : shift.staffingOffices) !== null && _b !== void 0 ? _b : {})[0];
    const staffingOfficeName = staffingOfficeID
        ? (_c = offices.getRaw(staffingOfficeID)) === null || _c === void 0 ? void 0 : _c.info.name
        : undefined;
    const updates = {
        [`${DbRef.USERS}/${nurseID}/shiftOffers/${shiftID}/declineReason`]: declineReason,
        [`${DbRef.USERS}/${nurseID}/shiftOffers/${shiftID}/status`]: ShiftOfferStatus.DECLINED,
        [`${DbRef.SHIFTS}/${shiftID}/nursesOffered/${nurseID}/declineReason`]: declineReason,
        [`${DbRef.SHIFTS}/${shiftID}/nursesOffered/${nurseID}/status`]: ShiftOfferStatus.DECLINED,
    };
    await dbGroupSet(updates);
    trackEvent(store, TrackingEvent.NURSE_DECLINED_SHIFT_OFFER, {
        shiftID,
        nurseID,
        nurseFullName,
        declineReason,
        staffingOfficeID,
        staffingOfficeName,
    }, true);
};
const cancelShift = async (request, skipNavigation = false) => {
    const { nurseJustDeclinedOrCanceledShiftIds } = useItineraryGeoSearch();
    try {
        const { dryRunUpdates } = await cancelShiftAsNurseRequest(request);
        nurseJustDeclinedOrCanceledShiftIds.add(request.shiftID);
        if (dryRunUpdates)
            console.info('dryRunUpdates', dryRunUpdates);
        toastSuccess('Shift canceled');
        if (!skipNavigation)
            await getRouter().push(portalJobsRoute());
    }
    catch (error) {
        toastError(error);
    }
};

export { cancelShift, declineShiftOffer };
